export enum PageRoutes {
  DESKTOP_HOME = "/desktop-home",
  LOGIN = "/login",
  REGISTER = "/register",
  PRICING = "/pricing",
  DASHBOARD = "/dashboard",
  PRIVACY = "/privacy",
  CHURCH_QR = "/dashboard/church/:churchId/qr",
  CURRENT_SERVICE = "/church/:churchId/service/current",
  CHURCH_PAGE = "/dashboard/church/:churchId",
  TRANSLATIONS = "/church/:churchId/service/:serviceId",
  CHURCH_SETTINGS = "/dashboard/church/:churchId/settings",
  SERVICE_DETAIL = "/dashboard/church/:churchId/service/:serviceId",
  SERVICE_DETAIL_TAB = "/dashboard/church/:churchId/service/:serviceId/:tab",
  NEW_SERVICE = "/dashboard/church/:churchId/service/new",
  HOME = "/",
  SPANISH_TRANSLATION = "/spanish-sermon-translation",
  MULTILINGUAL_CHURCHES = "/multilingual-churches",
  CHURCH_CAPTIONS = "/church-live-captioning",
  SUBSCRIBE = "/onboarding/subscribe/:churchId",
  BILLING_TEST = "/onboarding/billing/test/:churchId",
  BILLING_SUCCESS = "/onboarding/billing/success/:churchId",
  DONATE = "https://donate.stripe.com/bIYg0F9hodyl7XG6oo",
  EXAMPLE_YOUTUBE_VIDEO = "https://www.youtube.com/embed/93luVoOXUdg?si=bYT0IbqBDQVQeV-X",
  CREATE_CHURCH = "/onboarding/create-church",
  CHURCH_PENDING_REVIEW = "/dashboard/church/:churchId/pending-review",
}

export function buildRoute(
  route: string,
  vars: Record<string, string | number>
): string {
  return route.replace(/:([a-zA-Z]+)/g, (_, key) => {
    const value = vars[key];
    if (!value) throw new Error(`Missing variable for route: ${key}`);
    return encodeURIComponent(String(value));
  });
}
